import { useTQC2050_R01Store } from "./Store_TQC2050_R01";
import { ImageForm } from "src/components/common/form/ImageForm";
import { defaultTQC2050_R01HeaderDto } from "./Dto_TQC2050_R01";

export const Images_TQC2050_R01 = () => {
	const { editTQC2050_R01, setEditTQC2050_R01 } = useTQC2050_R01Store();

	const imageWrapperStyle = {
		wrapperStyle: "w-[260px] h-[260px]",
	};

	return (
		<div className="w-full h-full flex flex-row gap-4">
			<div className="flex-1">
				<ImageForm 
					title="시험 전 사진" 
					image={editTQC2050_R01?.beforeImage || ''} 
					onImageChange={(beforeImage) => setEditTQC2050_R01({ ...(editTQC2050_R01 ?? defaultTQC2050_R01HeaderDto), beforeImage })}
					wrapperOption={imageWrapperStyle} 
				/>
			</div>
			
		</div>
	);
};


